<template>
  <div class="my-10">
    <MyPublicationNav></MyPublicationNav>
    <!--        <div class="grid grid-cols-4 gap-4 max-lg:grid-cols-3 max-md:grid-cols-2 max-sm:grid-cols-1">-->
    <!--            <template v-for="item in publications" :key="item.id">-->
    <!--                <router-link :to="{ name: 'viewMyPublication', params: { id: item.id } }">-->
    <!--                    <PublicationCard :detail="item">-->
    <!--                    </PublicationCard>-->
    <!--                </router-link>-->
    <!--            </template>-->
    <!--            <div v-show="publications.length === 0 && loading === false">-->
    <!--                <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.no_publications') }}</p>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        <div v-show="loading === true" class="flex justify-center mt-10" role="status">-->
    <!--            <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">-->
    <!--            </IconSpinner>-->

    <!--            <span class="sr-only">Loading...</span>-->
    <!--        </div>-->
    <div class="grid grid-cols-4 gap-5">
      <div class="col-span-1 divide-y-2 max-md:hidden">
        <div>
          <p class="font-semibold text-xl mb-4">{{ $t('page.categories') }}</p>
          <div class="h-96 overflow-y-scroll fltrs">
            <ul class="space-y-3 row-list">
              <li>
                <router-link
                  class="text-main-color text-base font-semibold hover:text-accent-color"
                  :class="{ '!text-accent-color': currentCategory == null }"
                  :to="{ name: 'myPublications', query: { category: null, subscription: null } }"
                  >{{ $t('page.all') }}</router-link
                >
              </li>
              <li v-for="cat in $store.publicationCategories" :key="cat.id">
                <router-link
                  class="text-main-color text-base font-semibold hover:text-accent-color"
                  :class="{ '!text-accent-color': cat.id == currentCategory }"
                  :to="{
                    name: 'myPublications',
                    query: { category: cat.id, subscription: currentSubscription },
                  }"
                  >{{ cat.name }}</router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="my-5 py-5">
          <p class="font-semibold text-xl mb-4">{{ $t('page.status') }}</p>
          <div class="h-96 overflow-y-scroll fltrs">
            <ul class="space-y-3 row-list">
              <li>
                <router-link
                  class="text-main-color text-base font-semibold hover:text-accent-color"
                  :class="{ '!text-accent-color': currentSubscription == null }"
                  :to="{
                    name: 'myPublications',
                    query: { category: currentCategory, subscription: null },
                  }"
                  >{{ $t('page.all') }}</router-link
                >
              </li>
              <li>
                <router-link
                  class="text-main-color text-base font-semibold hover:text-accent-color"
                  :class="{ '!text-accent-color': currentSubscription == 1 }"
                  :to="{
                    name: 'myPublications',
                    query: { category: currentCategory, subscription: 1, is_vip: isVip },
                  }"
                  >GOLD</router-link
                >
              </li>
              <li>
                <router-link
                  class="text-main-color text-base font-semibold hover:text-accent-color"
                  :class="{ '!text-accent-color': currentSubscription == 2 }"
                  :to="{
                    name: 'myPublications',
                    query: { category: currentCategory, subscription: 2, is_vip: isVip },
                  }"
                  >SILVER</router-link
                >
              </li>
              <li>
                <router-link
                  class="text-main-color text-base font-semibold hover:text-accent-color"
                  :class="{ '!text-accent-color': currentSubscription == 3 }"
                  :to="{
                    name: 'myPublications',
                    query: { category: currentCategory, subscription: 3, is_vip: isVip },
                  }"
                  >BRONZE</router-link
                >
              </li>
              <li>
                <router-link
                  class="text-main-color text-base font-semibold hover:text-accent-color"
                  :class="{ '!text-accent-color': isVip == 'true' }"
                  :to="{
                    name: 'myPublications',
                    query: {
                      category: currentCategory,
                      subscription: currentSubscription,
                      is_vip: isVip == 'true' ? null : true,
                    },
                  }"
                  >VIP</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-span-3 max-md:col-span-4">
        <div class="grid grid-cols-3 gap-4 max-lg:grid-cols-2">
          <router-link
            v-for="item in publications"
            :key="item.id"
            :to="{ name: 'viewMyPublication', params: { id: item.id } }"
          >
            <PublicationCard
              :has_name="true"
              :has_price="item?.category_has_price"
              :detail="item"
            />
          </router-link>
          <div v-show="publications.length === 0 && loading === false">
            <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.no_publications') }}</p>
          </div>
        </div>
        <div v-show="loading === true" class="flex justify-center mt-10" role="status">
          <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin fill-main-color">
          </IconSpinner>

          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import PublicationCard from '@cmp/publication/PublicationCard.vue';
import MyPublicationNav from '@cmp/profile/MyPublicationNav.vue';
import IconSpinner from '@icons/IconSpinner.vue';
import { updateLastSeen } from '@/helpers';
export default {
  name: 'myPublications',
  components: {
    IconSpinner,
    PublicationCard,
    MyPublicationNav,
  },
  data() {
    return {
      loading: false,
      publications: [],
      page: 1,
      count: 0,
      next: null,
      currentSubscription: null,
      currentCategory: null,
      isVip: null,
    };
  },
  watch: {
    '$route.query.category': {
      //   immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.publications = [];
          this.currentCategory = newValue;
          this.page = 1;
          this.getMyPublications();
        }
      },
    },
    '$route.query.subscription': {
      //   immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.publications = [];
          this.currentSubscription = newValue;
          this.page = 1;
          this.getMyPublications();
        }
      },
    },
    '$route.query.is_vip': {
      //   immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.publications = [];
          this.isVip = newValue;
          this.page = 1;
          this.getMyPublications();
        }
      },
    },
  },
  methods: {
    infiniteScroll() {
      let scrollTop = document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      let clientHeight = document.documentElement.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 650) {
        if (this.next !== null && this.loading === false) {
          this.page += 1;
          this.getMyPublications();
        }
      }
    },
    async getMyPublications() {
      this.loading = true;
      try {
        const response = await api.get('publications/my-publications/', {
          params: {
            category: this.currentCategory,
            page: this.page,
            subscription: this.currentSubscription,
            is_vip: this.isVip,
          },
        });
        const results = response.data.results;
        results.forEach(element => {
          this.publications.push(element);
        });
        this.count = response.data.count;
        this.next = response.data.next;
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
  },
  computed: {},
  mounted() {
    window.addEventListener('scroll', this.infiniteScroll);
    updateLastSeen('published_publications');
  },
  unmounted() {
    window.removeEventListener('scroll', this.infiniteScroll);
  },
  created() {
    this.currentSubscription = this.$route.query.subscription;
    this.currentCategory = this.$route.query.category;
    this.isVip = this.$route.query.is_vip;
    this.getMyPublications();
  },
};
</script>
